// Living Avatar — score→state helpers + band labels. Per-user image URLs are
// resolved by AvatarContext; this module only holds the pure score→state mappings.

export const PILLARS = ['movement', 'recovery', 'nutrition', 'mental'];
export const STATE_ORDER = ['poor', 'fair', 'good', 'excellent'];
export const STATE_LABEL = { poor: 'Poor', fair: 'Fair', good: 'Good', excellent: 'Excellent' };

// score (0–100 | null) → state key. A null/no-reading pillar reads as the
// neutral 'fair' (never 'poor'), matching the backend composite (state_for).
export function pillarStateKey(score) {
  if (score === null || score === undefined) return 'fair';
  const s = Math.max(0, Math.min(100, score));
  if (s < 40) return 'poor';
  if (s < 60) return 'fair';
  if (s < 80) return 'good';
  return 'excellent';
}

// Composite Wellness IQ → a short band label + accent colour for the dashboard.
export function overallBand(score) {
  if (score === null || score === undefined) return { label: 'Asleep', color: '#52525b' };
  const s = Math.max(0, Math.min(100, score));
  if (s < 40) return { label: 'Dormant', color: '#fb923c' };
  if (s < 60) return { label: 'Stirring', color: '#fb923c' };
  if (s < 80) return { label: 'Steady', color: '#facc15' };
  return { label: 'Thriving', color: '#CCFF00' };
}
